import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import defaultStyle from '../common/search-control/search.style.js';
import { SearchableDropdown, RequiredLabel } from '../common';
import '../common/search-control/search.scss';

export class SiteProgramSearchComponent extends Component {

  render() {
    const { id, siteList, searchButtonLabel, currentSelectedSite, isSiteDisabled, isFetchingSites, programList, currentSelectedProgram, isProgramDisabled, isFetchingPrograms, handleUpdateSite, handleUpdateProgram, startSearch, css } = this.props;
    return (
      <div className="siteprogram-filter-dropdown">
          <div className="form-group row">
            <div className="col-sm-2 col-form-label text-right">
              <RequiredLabel isRequired={false} className="label-override" content={"Site"} htmlFor="site-select-dropdown-id" />
            </div>
            <div className="search-drop-down">
              <SearchableDropdown
                id="site-select-dropdown-id"
                instanceId="1"
                name="site-select-dropdown"
                options={siteList}
                value={currentSelectedSite || ""}
                isDisabled={isSiteDisabled}
                isLoading={isFetchingSites}
                onChange={newValue => handleUpdateSite(newValue.value)}
                autoFocus={true}
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col-sm-2 col-form-label text-right">
              <RequiredLabel isRequired={false} className="label-override" content={"Program"} htmlFor="program-select-dropdown-id" />
            </div>
            <div className="search-drop-down">
              <SearchableDropdown
                id="program-select-dropdown-id"
                instanceId="2"
                name="program-select-dropdown"
                options={programList}
                value={currentSelectedProgram || ""}
                isDisabled={isProgramDisabled}
                isLoading={isFetchingPrograms}
                onChange={newValue => handleUpdateProgram(newValue.value)}
                autoFocus={false}
              />
            </div>
            <div className="search-button">
              <button
                id={id + '-searchButton'}
                disabled={!!currentSelectedSite ? false : true}
                className={css.searchButton}
                onClick={e => startSearch()}>
                {searchButtonLabel}
              </button>
            </div>
          </div>
      </div>
    );
  }
}

SiteProgramSearchComponent.defaultProps = {
  searchButtonLabel: 'Search'
}

SiteProgramSearchComponent.propTypes = {
  siteList: PropTypes.array, //this is a list of sites
  currentSelectedSite: PropTypes.string,
  isSiteDisabled: PropTypes.bool,
  isFetchingSites: PropTypes.bool,
  programList: PropTypes.array, //this is a list of programs
  currentSelectedProgram: PropTypes.string,
  isProgramDisabled: PropTypes.bool,
  isFetchingPrograms: PropTypes.bool,
  handleUpdateSite: PropTypes.func,
  handleUpdateProgram: PropTypes.func,
  startSearch: PropTypes.func,
  searchButtonLabel : PropTypes.string,
};

export default styleable(defaultStyle)(SiteProgramSearchComponent);
